import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// import Renderer from '@tencent/gems-renderer-react';
import '../OldRender/handler';
import { FlexNavigate, FlexVideo } from '@tencent/cms-design-component';
// import Renderer from '@tencent/gems-renderer-react';
import materialsQci from 'gems-materials-qci/lib';
import BannerComponent from 'gems-materials-qci/lib/components/Banner';
import FlexNavigateComponent from 'gems-materials-qci/lib/components/FlexNavigate';
import NewBannerComponent from 'gems-materials-qci/lib/components/NewBanner';
import OperateComponent from 'gems-materials-qci/lib/components/Operate';
import React, { useCallback } from 'react';
import Renderer from '../../gems-render-lib';
import { asyncReceiveCommodity } from '../OldRender/handler';
import { getFormatUrlMethods } from '../OldRender/utils/url-utils';
import NewNoticeComponent from './NewNoticeComponent';
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function useCompNotEmpty() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return args.find(function(item) {
        return (item === null || item === void 0 ? void 0 : item.components) && Object.keys(item.components).length > 0;
    });
}
export default function GemsRender(props) {
    var ref5, ref1;
    var configData = props.configData, lang = props.lang, domains = props.domains;
    // 数据有缓存，避免改动需要二次复用的源数据
    var schema = JSON.parse(JSON.stringify(useCompNotEmpty(configData.langPage[lang], configData.langPage.en)));
    var filterConfigData = schema.components;
    var noticeData = filterConfigData.filter(function(item) {
        return item.name === 'Notice';
    });
    var Notice = function() {
        if (noticeData.length) {
            var noticeCom = noticeData.map(function(item) {
                return NewNoticeComponent(item.data);
            });
            return noticeCom;
        // return NewNoticeComponent(noticeData[0].data);
        // Notice组件比较特别，理论上一个页面只能有一个，所以这里固定取第一条数据
        }
        return '';
    };
    var bannerData = filterConfigData.filter(function(item) {
        return item.name === 'Banner' || item.name === 'NewBanner';
    });
    // 判断当前语种有没有配置banner组件，banner组件需要特别展示
    var Banner = function() {
        if (bannerData.length) {
            var Comp = bannerData[0].name === 'Banner' ? BannerComponent : NewBannerComponent;
            return(/*#__PURE__*/ _jsx(Comp, {
                data: bannerData[0].data,
                domains: domains
            }));
        // Banner组件比较特别，理论上一个页面只能有一个，所以这里固定取第一条数据
        }
        return '';
    };
    var AnotherBanner = function() {
        if (bannerData.length > 1) {
            var Comp = bannerData[0].name === 'Banner' ? BannerComponent : NewBannerComponent;
            return(/*#__PURE__*/ _jsx(Comp, {
                data: bannerData[1].data,
                domains: domains
            }));
        }
        return '';
    };
    // 活动运营组件在banner下面，导航上方，所以需要单独处理
    var operateData = filterConfigData.filter(function(item) {
        return item.name === 'Operate';
    });
    var Operate = function() {
        if (operateData.length) {
            return(/*#__PURE__*/ _jsx(OperateComponent, {
                data: operateData[0].data
            }));
        }
        return '';
    };
    // 处理沉浸式类型的banner，大学生、音视频banner，沉浸banner容器，导航不显示
    var immersiveBannerData = filterConfigData.filter(function(item) {
        return item.name === 'StudentCenterBanner' || item.name === 'AudiovideoBanner' || item.name === 'BannerContainer';
    });
    // 处理导航栏，因为布局原因fixed原因，所以需要单独处理
    var navigateData = filterConfigData.filter(function(item) {
        return item.name === 'FlexNavigate';
    }); // navigateData 低代码手动配置的FlexNavigate组件数据
    // 导航栏组件新增按钮 如果导航栏组件配了字段值则优先取该组件配置的值，否则取banner的第一个按钮的值
    var bannerBtnList = ((ref5 = bannerData[0]) === null || ref5 === void 0 ? void 0 : (ref1 = ref5.data) === null || ref1 === void 0 ? void 0 : ref1.buttonList) || [];
    var bannerBtn = bannerBtnList[0] || {};
    var bannerCommodityObject = bannerBtn.commodityObject || '';
    var resultCommodityObject = bannerCommodityObject && JSON.parse(bannerCommodityObject);
    var formatUrlString = getFormatUrlMethods({
        domains: domains
    }).formatUrlString;
    var btnLink = {
        link: formatUrlString(bannerBtn.href),
        txt: bannerBtn.label,
        commodityObject: bannerCommodityObject
    };
    var NewFlexNavigate = function() {
        var ref, ref2, ref3, ref4;
        var anchor = ((ref = navigateData[0]) === null || ref === void 0 ? void 0 : (ref2 = ref.data) === null || ref2 === void 0 ? void 0 : ref2.anchor) || [];
        var newBtnLink = formatUrlString(((ref3 = navigateData[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.btnLink) || '');
        if (!newBtnLink.txt) {
            newBtnLink = btnLink;
        }
        if (navigateData.length && anchor.length > 0) {
            return(/*#__PURE__*/ _jsx(FlexNavigateComponent, {
                data: _objectSpread({}, navigateData[0].data, {
                    btnLink: newBtnLink
                }),
                domains: domains
            }));
        }
        return '';
    };
    filterConfigData = filterConfigData.filter(function(item) {
        return ![
            'Notice',
            'Banner',
            'NewBanner',
            'Operate',
            'FlexNavigate'
        ].includes(item.name);
    });
    // 如果有banner Contact组件，其他展示区域剔除banner Contact模块
    var targets = filterConfigData.filter(function(item) {
        return ![
            'Banner',
            'NewBanner',
            'Contact',
            'Notice'
        ].includes(item.name);
    });
    // 从容器组件中的提取组件添加到导航数据中
    var doNavDataEvent = function(param) {
        var data = param.data;
        var ref, ref6, ref7;
        var porintId = data.porintId || ((ref = data.data) === null || ref === void 0 ? void 0 : ref.porintId) || '';
        var modTitle = data.modTitle || ((ref6 = data.data) === null || ref6 === void 0 ? void 0 : ref6.modTitle) || '';
        var flexTitle = data.flexTitle || ((ref7 = data.data) === null || ref7 === void 0 ? void 0 : ref7.flexTitle) || ''; // 兼容老组件使用的flexTitle字段
        var navTitle = modTitle || flexTitle;
        if (navTitle) {
            var item = {
                label: navTitle,
                anchorId: porintId || navTitle
            };
            navData.push(item);
        }
    };
    // 处理默认导航事件
    var doNavEvent = function() {
        if (targets.length) {
            targets.forEach(function(item1) {
                if (item1.name === 'MenuPanelContainer') {
                    item1.children.forEach(function(item) {
                        if (item.data.mergeComponentStatus) {
                            return;
                        }
                        doNavDataEvent(item);
                    });
                } else {
                    doNavDataEvent(item1);
                }
            });
        }
    };
    var navData = [];
    doNavEvent(); // 处理导航
    // 一级页面不显示模块导航
    var showFlexNavigate = ![
        'pricing',
        'partner',
        'customers'
    ].includes(configData.page_eid);
    if (immersiveBannerData.length > 0 || navigateData.length > 0) {
        showFlexNavigate = false;
    }
    schema.components = filterConfigData;
    var onNavigatorTabClick = useCallback(function(item, index) {
        var label = item && item.label;
        window.recordBehavior && window.recordBehavior.reportEvent('click_navigator_tab', {
            ext1: index + 1,
            ext2: label
        });
    }, []);
    return(/*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(Notice, {}),
            /*#__PURE__*/ _jsx(Banner, {}),
            /*#__PURE__*/ _jsx(Operate, {}),
            /*#__PURE__*/ _jsx(NewFlexNavigate, {}),
            showFlexNavigate && !!navData.length && /*#__PURE__*/ _jsx(FlexNavigate, {
                configuration: navData,
                btnLink: btnLink,
                onTabClick: onNavigatorTabClick,
                onCallBack: function() {
                    asyncReceiveCommodity(_objectSpread({}, resultCommodityObject, {
                        href: btnLink === null || btnLink === void 0 ? void 0 : btnLink.link
                    }));
                }
            }),
            /*#__PURE__*/ _jsx(Renderer, {
                lang: lang,
                schema: schema,
                materials: materialsQci
            }),
            /*#__PURE__*/ _jsx(FlexVideo, {
                postMessageUrl: '/solution-new/tcp-player'
            }),
            /*#__PURE__*/ _jsx(AnotherBanner, {})
        ]
    }));
};
